{
  "name": "webapp-register-aws-marketplace-app",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build-prod": "ng build --configuration=production --aot=true --optimization=true",
    "build-staging": "ng build --configuration=staging --aot=true --optimization=true",
    "build-dev": "ng build --configuration=development --aot=true",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "openapi": "rimraf src/app/core/openapi && npx @openapitools/openapi-generator-cli version-manager set 7.9.0 && npx @openapitools/openapi-generator-cli generate -g typescript-angular -i https://d2wm7bc5untnh4.cloudfront.net/swagger/customerbackoffice/customerbackoffice_v3/swagger.json -o src/app/core/openapi --additional-properties=ngVersion=18.2.0 --additional-properties=stringEnums=true --additional-properties=providedIn=none --additional-properties=withInterfaces=true --template-dir src/app/core/templates"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.2.0",
    "@angular/common": "^18.2.0",
    "@angular/compiler": "^18.2.0",
    "@angular/core": "^18.2.0",
    "@angular/forms": "^18.2.0",
    "@angular/platform-browser": "^18.2.0",
    "@angular/platform-browser-dynamic": "^18.2.0",
    "@angular/router": "^18.2.0",
    "@m1/components": "^1.0.0-beta.1684",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "^16.0.1",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.14",
    "@angular/cli": "^18.2.14",
    "@angular/compiler-cli": "^18.2.0",
    "@openapitools/openapi-generator-cli": "^2.16.3",
    "@types/jasmine": "~5.1.0",
    "jasmine-core": "~5.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "rimraf": "^6.0.1",
    "typescript": "~5.5.2"
  }
}
